@mixin windowFooter {
  display: flex;
  padding: 0 calc(5 * var(--spacer));
  min-height: 60px;
  position: relative;
  margin-top: auto;
  align-items: center;
  border-top: 1px solid var(--chart-050-hover);
  background: var(--white-layout-302-level-1-elevation);
}
